import { FieldPolicy } from '@apollo/client/cache/inmemory/policies'
import { ICarrierCallListResultFragment } from 'apps/marketplace/pages/shipment-details/components/CarrierCallList/graphql/CarrierCallListResultFragment'

const carrierCallListForShipmentFieldPolicy: FieldPolicy<
  ICarrierCallListResultFragment,
  ICarrierCallListResultFragment
> = {
  keyArgs: ['shipmentId', 'matchTypes', 'pickupRadius', 'deliveryRadius'],
  merge: (existing, incoming) => {
    const { matches: existingMatches = [] } = existing || {}
    const { matches: incomingMatches = [] } = incoming || {}
    return { ...incoming, matches: [...existingMatches, ...incomingMatches] }
  },
}

export default carrierCallListForShipmentFieldPolicy
